import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col md:flex-row items-center gap-4 md:gap-14" }
const _hoisted_2 = { class: "flex flex-grow flex-col md:flex-row sm:w-full items-center gap-4 md:gap-8" }
const _hoisted_3 = { class: "col-start-1 col-end-2 w-36 h-8" }
const _hoisted_4 = { class: "flex-grow" }

import LogoIcon from "@/components/icons/LogoIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'BookHeader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LogoIcon),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "button")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "input")
      ])
    ])
  ]))
}
}

})